import { Button, ButtonProps, PolymorphicComponentProps } from '@mantine/core'
import buttonClasses from './button.module.scss'

export const ErpButtonComponent = <C = 'button'>(props: PolymorphicComponentProps<C, ButtonProps>) =>
    <Button
        classNames={ buttonClasses }
        { ...props }
        component={ props.component as 'symbol' | undefined }
    />
